import React, { useEffect, useState } from "react";
import { getNewsInner } from "../Service/Api";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import LazyLoad from "react-lazyload";

const News = () => {

  const [newsData, setNewsData] = useState([]);
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getNewsInner();
        setNewsData(data);
      
      } catch (error) {
        console.error("Failed to fetch news:", error);
        setNewsData([]); // Set to empty to ensure the empty state is handled
      }
    };
    fetchData();
  }, []);
  const emptyArray = [
    {
      title: "Stay Tuned For More Updates",
      description: "Stay Tuned For More Updates",
    },
    {
      title: "Stay Tuned For More Updates",
      description: "Stay Tuned For More Updates",
    },
    {
      title: "Stay Tuned For More Updates",
      description: "Stay Tuned For More Updates",
    },
  ];

  const settings = {
    autoplay: true,
    infinite: true,
    autoplaySpeed: 2000,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: false,
    adaptiveHeight: true,
    responsive: [
      { breakpoint: 1400, settings: { slidesToShow: 2 } },
      { breakpoint: 992, settings: { slidesToShow: 2 } },
      { breakpoint: 767, settings: { slidesToShow: 2 } },
      { breakpoint: 600, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <>
      <div className="eventbg">
        <Slider {...settings}>
          {newsData.length > 0
            ? newsData.map((item, index) => {
              const date = new Date(item.fromDate);
              const mon = monthNames[date.getMonth()];
              const eventdate = date.getDate();
              console.log(mon);
              return(
                <div className="item" key={index}>
                <div className="homeeventbox newseventbg">
                  <div className="homeeventboximg">
                   <div className="date"> {eventdate}, {mon} </div>
                    <div className="attch">
                      <Link
                        to={`https://webapi.entab.info/api/image/${item?.attachments}`}
                        target="_blank">
                        <i className="bi bi-paperclip"></i>{" "}
                      </Link>
                    </div>
                    <LazyLoad>{item.image.length > 0 ? (<img src={`https://webapi.entab.info/api/image/${item.image}`} className="img-fluid" alt="Mercy Memorial School, Kanpur" />) : (<img src="https://webapi.entab.info/api/image/MMSKN/public/Images/news.jpg" className="img-fluid" alt="Mercy Memorial School, Kanpur" />)} </LazyLoad>
                     
                  </div>
                  <div className="homeeventboxdesc">
                    <div className="homeeventboxtitle">
                      <h3>{item.title}</h3>
                      <p>{item.description}</p>
                    </div>
                    <div className="homeeventboxbottom">
                      <Link to="/News">      <span>
                             Read More
                            </span> </Link> 
                          </div>
                  </div> 
                </div>
              </div>
              )
            })
            : emptyArray.map((data, index) => (
              <div className="item" key={index}>
                <div className="homeeventbox newseventbg">
                  <div className="homeeventboximg">
                  <div className="date"> DD MM</div>
                    <LazyLoad><img
                      src="https://webapi.entab.info/api/image/MMSKN/public/Images/news.jpg"
                      className="img-fluid"
                      alt="Mercy Memorial School, Kanpur"
                    /></LazyLoad>
                     
                  </div>
                  <div className="homeeventboxdesc">
                    <div className="homeeventboxtitle">
                      <h3>{data.title}</h3>
                      <p>{data.description}</p>
                    </div>
                    <div className="homeeventboxbottom">
                            <span>
                             Read More
                            </span>
                          </div>
                  </div>
                  
                </div>
              </div>
            ))}
        </Slider>
        <button className="button text-center m-auto">
          <Link to="/News">Read More <i className="bi bi-arrow-right"></i></Link>
        </button>
      </div>
    </>
  );
};

export default News;
